// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Graph = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Graph = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Graph = _exports.Graph = function Graph(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M1.42773 12.7986V12.7986C3.42841 12.7986 5.11796 11.3131 5.37399 9.32883L6.07432 3.90123C6.21807 2.78719 7.16667 1.95312 8.28995 1.95312V1.95312C9.52375 1.95312 10.5239 2.95332 10.5239 4.18712V15.9561C10.5239 17.1106 11.4598 18.0464 12.6142 18.0464V18.0464C13.6305 18.0464 14.4995 17.3155 14.6736 16.3143L15.2922 12.7572C15.5694 11.1633 16.9528 9.99977 18.5706 9.99977V9.99977",
      stroke: "#212B36",
      "stroke-width": "1.25"
    }));
  };
});
